import { Button } from "../../components/ui/button";
import { LogIn } from "lucide-react";
import Seo from "../../components/Seo";

export default function AdminLogin() {
  const onLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <>
      <Seo title="Admin login — Lime Driving School" robots="noindex,nofollow" />
      <div className="min-h-screen bg-[#FDFCFB] grid place-items-center px-4" data-testid="admin-login-page">
        <div className="max-w-md w-full bg-white border border-black/5 rounded-3xl p-8 shadow-sm">
          <div className="flex items-center gap-2 mb-6">
            <img src="https://customer-assets.emergentagent.com/job_lime-booking-hub/artifacts/xf9up4et_logo-header-only.png"
                 alt="Lime Driving School" className="h-10 w-auto" />
          </div>
          <h1 className="text-2xl sm:text-3xl tracking-tight font-medium" style={{fontFamily:"Outfit, sans-serif"}}>Instructor login</h1>
          <p className="mt-2 text-sm text-[#4B5563]">Sign in with the Google account configured as admin to manage bookings, orders and content.</p>
          <Button onClick={onLogin} className="mt-8 w-full h-12 bg-[#111827] hover:bg-[#374151] text-white" data-testid="google-login-btn">
            <LogIn className="h-4 w-4 mr-2" /> Continue with Google
          </Button>
        </div>
      </div>
    </>
  );
}
